export const environment = {
  production: false,
  id: '4l',
  serverUrl: 'https://4l.superlikerslabs.com',
  photosPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/upload-photo'
}
